import { FC, useState } from "react";
import HeadSection from "../../components/HeadSection";
import i18n from "../../i18n";
import { useTranslation } from "react-i18next";
import { title } from "process";
import { iconButtonClasses } from "@mui/material";
import Filter from "../../widgets/filter";
import { catalogTranslations } from "./catalog_translation";

i18n.addResourceBundle('en', 'catalog', catalogTranslations.en);
i18n.addResourceBundle('fr', 'catalog', catalogTranslations.fr);

interface CatalogProps  {
    nom:String,
};

const Catalog: FC<any> =() => {
    const [filter, setFilter] = useState<string>("");

    const handleFilterChange = (newFilter: string) => {
      setFilter(newFilter);
      console.log("Selected filter:", newFilter);
    };
    const { t } = useTranslation('catalog');
    return ( <>
    <div className="flex min-h-[80%] flex-col px-[3%] text-xl lg:px-[15%]">
        <HeadSection title={t('titles.head1')} trailling={<Filter onFilterChange={handleFilterChange }/>
            } style={""}></HeadSection>
        <section className="flex min-h-[200px] w-full items-center justify-center"> section all event 1 <br /> {filter} </section>
 
      </div></>);
}
export default Catalog;